import { useLenis } from "../hooks/useLenis";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { News } from "../components/News";
import { Marquee } from "../components/Marquee";
import { Manifesto } from "../components/Manifesto";
import { Gallery } from "../components/Gallery";
import { Instructors } from "../components/Instructors";
import { Schedule } from "../components/Schedule";
import { Pricing } from "../components/Pricing";
import { AppDownload } from "../components/AppDownload";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";

export default function Landing() {
  useLenis();
  return (
    <div className="grain relative bg-black min-h-screen">
      <Navbar />
      <main id="main-content">
        <Hero />
        <News />
        <Marquee />
        <Manifesto />
        <Gallery />
        <Instructors />
        <Schedule />
        <Pricing />
        <AppDownload />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
